export enum SkillLabel {
  Feedback = 'ai_recommendation:feedback',
  Occupation = 'ai_recommendation:occupation',
  ManuallyAdded = 'manual',
}

export interface SkillDesignation {
  id: number;
  // name_en: string;
  // name_pt: string;
  score: number;
  label?: SkillLabel;
  skill: Skill;
}

export interface Skill {
  id: number;
  name_en: string;
  name_pt: string;
  confidence?: number;
  description_en?: string;
  description_pt?: string;
  score?: number;
  source?: SkillLabel;
}
